import { useState } from "react";
import { toast } from "sonner";
import { BellRing, CheckCircle2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Input } from "./ui/input";

export const NotifyMe = ({ productId }) => {
  const { user } = useAuth();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [saving, setSaving] = useState(false);

  const subscribe = async () => {
    setSaving(true);
    try {
      await api.post("/stock-alerts", { product_id: productId, email: user ? undefined : email.trim() });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not subscribe. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  if (done) {
    return (
      <div className="mt-4 flex items-center gap-2 text-sm text-[#2D6A4F]" data-testid="notify-success">
        <CheckCircle2 className="w-4 h-4 shrink-0" /> You're on the list — we'll email you the moment it's back.
      </div>
    );
  }

  return (
    <div className="mt-4" data-testid="notify-me-block">
      <p className="text-sm text-[#6E675F] mb-3">Want it? We'll email you the moment it's restocked.</p>
      <div className="flex flex-col sm:flex-row gap-2 max-w-md">
        {!user && (
          <Input
            type="email"
            data-testid="notify-email-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@email.com"
            className="flex-1 bg-white"
          />
        )}
        <button
          data-testid="notify-me-button"
          onClick={subscribe}
          disabled={saving || (!user && !email.trim())}
          className="inline-flex items-center justify-center gap-2 bg-[#1A1A1A] text-white text-xs tracking-[0.15em] uppercase font-semibold px-6 py-3 rounded-none hover:bg-[#333333] transition-colors disabled:opacity-50"
        >
          <BellRing className="w-4 h-4" /> {saving ? "Saving…" : "Notify Me"}
        </button>
      </div>
      {user && <p className="text-xs text-[#6E675F] mt-2">We'll email {user.email}</p>}
    </div>
  );
};
